// lib/supabaseHelpers.ts
import { supabase } from "./supabaseClient";

export async function addProgramPoint({
  trip_id,
  title,
  description,
  category,
  start_time,
  end_time,
}: {
  trip_id: string;
  title: string;
  description?: string;
  category: "Reisen" | "Verpflegung" | "Kunst" | "Aktivität" | "Workshop";
  start_time: string; // ISO format
  end_time: string;
}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("trip_program_items")
    .insert([{ trip_id, title, description, category, start_time, end_time, creator_id: user.id }]);

  if (error) {
    throw error;
  }

  return data;
}

export async function createTodo(todo: {
  trip_id: string;
  title: string;
  description?: string;
  phase: "before" | "during" | "after";
  required: boolean;
  due_date?: string;
}) {
  const { data: userData, error: userError } = await supabase.auth.getUser();

  if (userError || !userData?.user?.id) {
    throw new Error("User nicht authentifiziert");
  }

  const { id: user_id } = userData.user;

  const { data, error } = await supabase
    .from("trip_todos")
    .insert([
      {
        trip_id: todo.trip_id,
        title: todo.title,
        description: todo.description,
        phase: todo.phase,
        required: todo.required,
        due_date: todo.due_date,
        created_by: user_id, // 🧩 Wichtige Zeile
      },
    ])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function assignTodoToUsers(todo_id: string, user_ids: string[]) {
  const assignments = user_ids.map((user_id) => ({
    todo_id,
    user_id,
  }));

  const { data, error } = await supabase
    .from("trip_todo_assignments")
    .insert(assignments);

  if (error) throw error;
  return data;
}

export async function getTodosWithAssignments(trip_id: string) {
  const { data, error } = await supabase
    .from("trip_todos")
    .select(
      `
      *,
      trip_todo_assignments (
        user_id,
        status,
        comment,
        updated_at
      )
    `
    )
    .eq("trip_id", trip_id)
    .order("due_date", { ascending: true });

  if (error) throw error;
  return data;
}

export async function addVirtualParticipant(tripId: string, firstName: string, lastName: string, email?: string) {
  // 1. Virtuelles Profil erstellen
  const { data: profile, error: insertError } = await supabase
    .from("virtual_profiles")
    .insert([{ first_name: firstName, last_name: lastName, email }])
    .select()
    .single();

  if (insertError) throw insertError;

  // 2. Trip-Teilnehmer erstellen mit virtual_profile_id
  const { error: participantError } = await supabase
    .from("trip_participants")
    .insert([{ trip_id: tripId, virtual_profile_id: profile.id }]);

  if (participantError) throw participantError;

  return profile;
}
